import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import SchedulingSlotSummary from './SchedulingSlotSummary';
import DaySlotPicker from './DaySlotPicker';
import { UseTimeSlotSelectionReturn } from './useTimeSlotSelection';

interface TimeSlotControlProps extends UseTimeSlotSelectionReturn {
  from?: string;
}

const TimeSlotControl = ({
  from,
  tab,
  selection,
  filterTab,
  filterDay,
  otherValue,
  otherSelected,
  slots,
  days,
  isSchedulingView,
  showSchedulingError,
  isSlotSelected,
  onDaySelect,
  onFilterTabSelect,
  onSlotToggle,
  onOtherToggle,
  onOtherValueChange,
}: TimeSlotControlProps) => {
  if (from !== 'srscheduling') {
    return (
      <DaySlotPicker
        days={days}
        slots={slots}
        tab={tab}
        otherSelected={otherSelected}
        otherValue={otherValue}
        isSlotSelected={isSlotSelected}
        onDaySelect={onDaySelect}
        onSlotToggle={onSlotToggle}
        onOtherToggle={onOtherToggle}
        onOtherValueChange={onOtherValueChange}
      />
    );
  }

  if (!isSchedulingView) {
    return null;
  }

  if (showSchedulingError) {
    return (
      <Callout
        variant="error"
        title="We couldn't load scheduling times"
        subtitle="It doesn't look like there are any valid time slots to schedule for this request. If this doesn't look right, please contact support."
      />
    );
  }

  return (
    <SchedulingSlotSummary
      filterDay={filterDay}
      filterTab={filterTab}
      selection={selection}
      onFilterTabSelect={onFilterTabSelect}
    />
  );
};

export default TimeSlotControl;